// Joriy foydalanuvchi haqidagi ma'lumot tokenning o'zidan olinadi.
//
// Bu faqat KO'RINISHNI boshqarish uchun: qaysi menyu bandi chiqishi,
// qaysi tugma bloklanishi. Haqiqiy ruxsat serverda tekshiriladi —
// tokenni o'zgartirib menyuni ochgan odam ham API'dan 403 oladi.

const yuk = () => {
  try {
    return JSON.parse(atob(localStorage.getItem('token').split('.')[1]));
  } catch {
    return null;
  }
};

export const joriyId = () => yuk()?.id ?? null;

export const joriyRol = () => yuk()?.role ?? null;

// Probatsiya xodimi panelning boshqa bo'limlariga kirmaydi — faqat o'z
// tumanining probatsiya ishini ko'radi.
export const probatsiyachimi = () => joriyRol() === 'probatsiya';

export const adminmi = () => joriyRol() === 'admin';

// Admin barcha tumanlarni nazorat qiladi, lekin bir vaqtda bittasini
// ko'radi. Tanlangan tuman shu yerda saqlanadi va har bir probatsiya
// so'roviga `x-tuman-id` sarlavhasi bo'lib qo'shiladi (authInterceptor.js).
// Server bu sarlavhani FAQAT admin uchun o'qiydi — tuman xodimi uni
// o'zgartirib boshqa tumanga o'ta olmaydi.
const TUMAN_KALITI = 'admin_tuman';

export const tanlanganTuman = () => {
  try {
    return localStorage.getItem(TUMAN_KALITI);
  } catch {
    return null;
  }
};

export const tumanniTanla = (id) => {
  try {
    if (id) localStorage.setItem(TUMAN_KALITI, String(id));
    else localStorage.removeItem(TUMAN_KALITI);
  } catch {
    // Brauzer saqlashni bloklagan — tanlov shu sahifada qoladi xolos.
  }
};
